<template>
  <v-container class="fill-height">
    <v-card
      width="100%"
      height="100%"
      style="display: grid;place-items: center;"
    >
      <p class="text-h3">Страница находится в разработке <v-icon large color="blue">mdi-robot</v-icon></p>
    </v-card>
  </v-container>
</template>

<script>


export default {
  name: 'OnDevelopment',
  components: {
  },
  data() {
    return {
    }
  },

  computed: {},

  watch: {},

  methods: {},

  async mounted() {},
}
</script>

<style>

</style>
